import Box from "@mui/material/Box";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

import { actionChangeFilter } from "./SearchRedux";

const root_ = (theme) => ({
  width: 500,
  maxWidth: "90vw",
  margin: "auto",
  marginTop: "5px",
  marginBottom: "5px",
  overflow: "auto",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    width: 0,
    height: 0,
  },
  [theme.breakpoints.down("sm")]: {
    margin: "10px 0",
    maxWidth: "85vw",
  },
});

const container_ = (theme) => ({
  width: 700,
  "& button": {
    marginRight: "6px",
    padding: "5px 9.5px",
  },
});

const scrollBtn_ = (theme) => ({
  padding: "4px",
  position: "absolute",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
});

const left_ = (theme) => ({
  left: 15,
});

const right_ = (theme) => ({
  right: 15,
});

const filterBtnActive_ = (theme) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: theme.palette.primary.light,
  },
});

export default function Filters() {
  const root = useRef(null);
  const filterBy = useSelector((state) => state.searchReducer.filterBy);
  const dispatch = useDispatch();

  const scrollHandler = (direction) => () => {
    const nonValidElt =
      !root ||
      !root.current ||
      (root.current && root.current.scrollLeft === null);

    if (nonValidElt) {
      return;
    }

    if (direction === "left") {
      root.current.scrollLeft -= 100;
    } else if (direction === "right") {
      root.current.scrollLeft += 100;
    }
  };

  const clickHandler = (filterType) => () => {
    dispatch(actionChangeFilter(filterType));
  };

  return (
    <Box sx={root_} ref={root}>
      <IconButton
        sx={[scrollBtn_, left_]}
        onClick={scrollHandler("left")}
        size="large"
      >
        <ArrowLeftIcon />
      </IconButton>
      <IconButton
        sx={[scrollBtn_, right_]}
        onClick={scrollHandler("right")}
        size="large"
      >
        <ArrowRightIcon />
      </IconButton>
      <Box sx={container_}>
        <Button
          variant="outlined"
          onClick={clickHandler("buildings")}
          sx={[filterBy === "buildings" && filterBtnActive_]}
        >
          Buildings
        </Button>
        <Button
          variant="outlined"
          onClick={clickHandler("rooms")}
          sx={[filterBy === "rooms" && filterBtnActive_]}
        >
          Rooms
        </Button>
        <Button
          variant="outlined"
          onClick={clickHandler("people")}
          sx={[filterBy === "people" && filterBtnActive_]}
        >
          People
        </Button>
        <Button
          variant="outlined"
          onClick={clickHandler("departments")}
          sx={[filterBy === "departments" && filterBtnActive_]}
        >
          Departments
        </Button>
        <Button
          variant="outlined"
          onClick={clickHandler("roomtypes")}
          sx={[filterBy === "roomtypes" && filterBtnActive_]}
        >
          Room Types
        </Button>
      </Box>
    </Box>
  );
}
